import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import SpotDetail from "./pages/SpotDetail";

function Header() {
  return (
    <header className="app-header">
      <Link to="/" className="brand">
        <span className="logo">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="" />
        </span>
        <span>
          <h1>Singapore Skate Spots</h1>
          <p className="sub">Find skatespots near you!</p>
        </span>
      </Link>
      <span className="header-pill">
        Discover spots across <b>Singapore</b>
      </span>
    </header>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/spots/:spotID" element={<SpotDetail />} />
      </Routes>
    </BrowserRouter>
  );
}
